// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"text-v1_textWrapper__qw_0i","textWrapper--hasDisplayStyle":"text-v1_textWrapper--hasDisplayStyle__q_VoF","text":"text-v1_text__RY7I4"};